import { Facebook, Linkedin, Twitter } from "react-feather";
import { FacebookIcon, LinkedInIcon, TwitterIcon } from "../../../Constant";
import { Btn } from "../../../AbstractElements";

export const OtherWay = () => {
  return (
    <>
      <div className="social mt-4">
        <div className="btn-showcase">
          <Btn color="light" tag="a" href="https://www.linkedin.com/login" target="_blank">
            <Linkedin className="txt-linkedin" /> {LinkedInIcon}
          </Btn>
          <Btn color="light" href="https://twitter.com/login?lang=en" target="_blank">
            <Twitter className="txt-twitter" /> {TwitterIcon}
          </Btn>
          <Btn color="light" href="https://www.facebook.com/" target="_blank">
            <Facebook className="txt-fb" /> {FacebookIcon}
          </Btn>
        </div>
      </div>
    </>
  );
};
